export default "__VITE_ASSET__CJgfKiuH__"